/* eslint-disable-next-line prefer-regex-literals */
const httpPrefixRegex = new RegExp('^(http|https)://', 'i');

const normalize = (url) => (httpPrefixRegex.test(url || '')
  ? url
  : `//${url}`);

export default {
  normalize,
};
